import { render, staticRenderFns } from "./CorporateStaffDashboard.vue?vue&type=template&id=772b0fc2&scoped=true&"
import script from "./CorporateStaffDashboard.vue?vue&type=script&lang=ts&"
export * from "./CorporateStaffDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./CorporateStaffDashboard.vue?vue&type=style&index=0&id=772b0fc2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772b0fc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardText,VCardTitle,VCol,VContainer,VRow,VSpacer})
